import { ClinicalWaitingList } from "@/Common/Api/Lists/Dto/ClinicalWaitingList";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { AddNewListPopupControl } from "./AddNewListPopupControl";

interface IListsTreeControlProps {
    Model: Immutable.List<ClinicalWaitingList>;
    ShowAddNewListPopup: boolean;
}

class ListsTreeControl extends React.Component<IListsTreeControlProps, never> {
    public render(): JSX.Element {
        return (
            <div onClick={e => this.StopPropagation(e)}>
                <ul className="accordion leftNavAccordion" data-accordion="">
                    <div className="displaced-nav-btns">
                        <a onClick={e => this.OnAddNewListClick(e)} className="plus_icon pull-left">&nbsp; </a>
                        <div><a style={{ marginLeft: "10px" }} className="bold" onClick={() => this.OnTitleclick()}> {cacheStore.GetString("WaitingListItemLabel")} </a></div>
                        <div data-hvar="-42" className="pull-left fxheight" style={{ overflow: "auto" }}>
                            {this.props.Model.toArray().map(item => (
                                <li className="accordion-navigation clearfix" key={item.Id}>
                                    <div style={{ "display": "inline-flex" }}>
                                        <div className="lists-tree-ellipsis">
                                            <a onClick={e => this.OnListClick(item.Id, item.Name, e)} title={item.Name}> {item.Name} </a>
                                        </div>
                                        {item.Count > 0 && (
                                            <div>
                                                <span style={{ "color": "whitesmoke" }}> {" (" + item.Count + ")"}</span>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </div>
                    </div>
                    <div className="clearfix" />
                </ul>
                {this.props.ShowAddNewListPopup && (
                    <AddNewListPopupControl
                        ContainerId="AddNewListDialog"
                        onCancel={() => { sessionStore.dispatch(LocalOperations.Lists.AddNewList_Popup_Cancel); }}
                        onSave={listName => this.onSaveNewList(listName)}
                    />
                )}
            </div>
        );
    }

    private OnTitleclick(): void {
        sessionStore.dispatch(LocalOperations.Lists.OnListTreeTitleClick);
    }
    private StopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }
    public OnListsCreateClick(): void {
        sessionStore.dispatch(LocalOperations.Lists.Show_Create_List);
    }
    public OnAddNewListClick(e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(LocalOperations.Lists.AddNewList_ShowPopup);
    }
    public OnListClick(id: string, name: string, e: React.MouseEvent): void {
        e.preventDefault();
        sessionStore.dispatch(LocalOperations.Lists.List_Selected, { listId: id, listName: name });
    }
    private onSaveNewList = (listName: string): void => {
        sessionStore.dispatch(LocalOperations.Lists.AddNewList_Popup_Ok, { value: listName });
    };
}

export { ListsTreeControl };
